import * as React from 'react';
import { withMemo } from 'PyzShopUi/scripts/react/common/hoc/withMemo';
import LinkButton from '../../react/common/components/form/LinkButton';
import Tooltip from '../../react/common/components/Tooltip';
import { translate } from 'PyzShopUi/scripts/utils/translate';
import { HelmetBuyerGuideTeaser } from './HelmetBuyerGuideTeaser';

interface IHelmetBuyerGuideLandingState {
    categoryKey: string;
    helmetBuyerGuidePageLink: string;
}

const categoryKeysHavingHBGLanding = ['c-836', 'c-837', 'm-150', 'c-833', 'c-832'];

const HelmetBuyerGuideLandingComponent: React.FunctionComponent<IHelmetBuyerGuideLandingState> = props => {
    const { categoryKey, helmetBuyerGuidePageLink } = props;

    if (!categoryKeysHavingHBGLanding.includes(categoryKey)) {
        return null;
    }

    return (
        <HelmetBuyerGuideTeaser additonalClassnames='hbg-teaser--catalog-page'>
            <h2>
                {translate(`The Louis helmet buyer's guide`, 'helmet-buyer-guide')}

                <Tooltip
                    content={<p>{translate(`The unique helmet buyer's guide enables you...`, 'helmet-buyer-guide')}</p>}
                    id='tooltip-hbg-landing-info'
                    isHoverEnabled={false}
                />
            </h2>

            <LinkButton
                additionalClass='button-bordered button-teaser'
                label={translate(`To helmet buyer's guide`, 'helmet-buyer-guide')}
                icon='arrow'
                href={helmetBuyerGuidePageLink}
                iconPosition='right'
            />
        </HelmetBuyerGuideTeaser>
    );
};

export const HelmetBuyerGuideLanding = withMemo(HelmetBuyerGuideLandingComponent);
